export default __webpack_public_path__ + "static/media/LeftArrow.0d693a05.svg";